import { createTheme } from '@material-ui/core/styles';
import  config  from '../config.json';
import '../css/index.css';

const selectboxFontStyle = {
  fontFamily: 'Barlow',
  fontSize: '13px',
  lineHeight: '15px',
  display: 'flex',
  alignItems: 'center',
  letterSpacing: '0.5px',
};

export const colors = {
  colorPrimary: '#56CCF2',
  colorSecondary: '#455157',
  colorSuccess: '#3B953E',
  colorRed: '#EB5757',
  colorInfo: '#58C8FD',
  colorGreen: '#50AD55',
  colorRefresh: '#219653',
  colorWhite: '#FFFFFF',
  colorBlack: '#3A3A3A',
  colorBackground: '#E5E5E5',
  colorDisabled: '#9A9A9A',
  colorWarning: '#EEA345',
  colorBorder: '#CCCCCC',
  colorTitle: '#AAAAAA',
  colorGrayLine: '#EEEEEE',
  colorText: '#1D9700',
};

export const lightModeColor = {
  drawerTextColor: '#222A35',
  drawerBackgroundColor: '#E0E0E0',
  drawerSelectContentBackGroundColor: '#B9D1B3',
  drawerSelectTextColor: '#1D9700',
};

export const darkModeColor = {
  drawerTextColor: '#989898',
  drawerBackgroundColor: '#222A35',
  drawerSelectContentBackGroundColor: '#07041C',
  drawerSelectTextColor: '#1D9700',
};

const getTheme = () => {
  // const themeMode = useSelector((state: RootState) => state.theme.mode);
  const primaryColor = config.backgroundColor
  let themePalette: any = {
    action: {
      // hover: 'rgba(29, 151, 0, 0.04)',
      // selected: 'rgba(29, 151, 0, .3)',
      hover:`${primaryColor}0A`,
      selected:`${primaryColor}4D`
    },
    background: {
      // paper: '#222A35',/* dark */
      paper: '#E0E0E0' /* dark */,
      default: '#ECEBED',
    },
    text: {
      primary: '#222A35',
    },
  };
    themePalette = {
      ...themePalette,
      background: {
        //  paper: '#222A35',/* dark */
        paper: '#222A35',
        default: '#07041C' /* dark */,
      },
      action: {
        hover: 'rgba(29, 151, 0, 0.04)',
        selected: '#07041C',
      },
      text: {
        primary: '#F8F7FA',
      },
      // for data-block tabs
      grey: {
        // active tab background color data-block area
        A800: '#2E353F',
        // active tab and default tab data-block area
        A900: primaryColor,
        // side bar font color -typography
        A1000: '#989898',
        A1100: '#989898',
        A1200:'#7A7F86',
        A1300:'#F8F7FA',
        A1400:primaryColor
      },
    };
  const theme = createTheme({
    //@ts-ignore
    listIconWidth: 43,
    palette: {
      type: 'dark',
      ...themePalette,
      common: {
        black: '#000',
        white: '#fff',
      },
      primary: {
        // main: '#1D9700',
        main: primaryColor
      },
      secondary: {
        light: '#ff4081',
        main: '#f50057',
        dark: '#c51162',
        contrastText: '#fff',
      },
      error: {
        main: colors.colorRed,
      },
      warning: {
        main: colors.colorWarning,
      },
      info: {
        main: colors.colorInfo,
      },
      success: {
        main: colors.colorSuccess,
      },
      grey: {
        50: '#fafafa',
        100: '#f5f5f5',
        200: '#eeeeee',
        300: '#e0e0e0',
        400: '#bdbdbd',
        500: '#9e9e9e',
        600: '#757575',
        700: '#616161',
        800: '#424242',
        900: '#212121',
        A100: '#d5d5d5',
        A200: '#aaaaaa',
        A400: '#303030',
        A700: '#616161',
        // For Data-block tabs
        A800: '#D2D2D2',
        A900: '#222A35',
        A1000: '#222A35',

        A1100: '#7C7C7C',
        A1200: '#989898',
        A1300:'#222A35',
        A1400: '#000000',
        ...themePalette.grey,
      },
    },
    typography: {
      fontFamily: `'Barlow','OCRBM','Calibri'`,

      h1: {
        fontSize: 24,
      },
      h2: {
        fontSize: 20,
      },
      h3: {
        fontSize: 16,
      },
      h4: {
        fontSize: 14,
        lineHeight: 'normal',
      },
      h5: {
        fontSize: 12,
      },
    },
  });
  theme.overrides = {
    MuiListItem: {
      root: {
        '& .MuiInputBase-root-253': {
          color: 'rgba(0, 0, 0, 0.87)',
          cursor: 'text',
          display: 'inline',
          position: 'relative',
          boxSizing: 'border-box',
          alignItems: 'center',
          fontSize: '0.5rem !important',
          fontFamily: `'OCRBM','Calibri','Barlow'`,
          fontWeight: 400,
          lineHeight: '1.1876em',
        },
        '& .MuiIconButton-root': {
          backgroundColor: '#222A35',
        },

        // side bar icon and text color//
        '& .MuiListItemIcon-root': {
          color: `${theme.palette.grey['A1000']} !important`,
        },
        '& .MuiSvgIcon-root': {
          '& path': {
            fill: `${theme.palette.grey['A1000']}`,
          },
        },
        '&$selected': {
          color: theme.palette.primary.main,
          '& .MuiTypography-body1, & .MuiListItemIcon-root': {
            color: theme.palette.primary.main,
          },
        },
        // side bar hover effect
        '&:hover': {
          '& .MuiListItemIcon-root': {
            color: theme.palette.primary.main,
          },
          '& .MuiTypography-body1': {
            color: theme.palette.primary.main,
          },
          '& .MuiSvgIcon-root': {
            '& path': {
              fill: theme.palette.primary.main,
            },
          },
        },

        // svg icon on theme color applied //
        '&.Mui-selected': {
          '& path': {
            fill: `${theme.palette.primary.main} !important`,
          },
        },
      },
    },
    MuiTooltip: {
      popper: {
        zIndex: 99999,
      },
      arrow: {
        color: theme.palette.common.black,
      },
      tooltip: {
        backgroundColor: theme.palette.common.black,
        fontSize: 13,
      },
    },
    MuiTypography: {
      h3: {
        color: 'unset',
      },
      body1: {
        fontFamily: 'Barlow',
        fontWeight: 600,
        fontSize: '13px',
        lineHeight: '15px',
        letterSpacing: '0.5px',
        // color: theme.palette.text.primary,

        // side bar content text color ex (Tables,Overlay)
        color: theme.palette.grey['A1000'],
      },
      h4: {
        fontSize: '2.125rem',
      },
    },
    MuiPaper: {
      elevation8: {
        boxShadow: 'none !important',
      },
    },
    MuiCardHeader: {
      root: {
        padding: '8px 13px',
        height: '35px',
      },
      subheader: {
        fontFamily: 'Barlow',
        fontWeight: 600,
        fontSize: '13px',
        lineHeight: '15px',
        display: 'flex',
        color: theme.palette.primary.main,
        alignItems: 'center',
        letterSpacing: '0.5px',
      },
    },
    MuiFormControlLabel: {
      root: {
        marginLeft: 0,
        marginRight: 0,
      },
    },
    MuiListItemText: {
      root: {
        padding: '0 5px',
      },
    },
    MuiInputAdornment: {
      positionStart: {
        marginRight: '4px',
      },
    },
    MuiSelect: {
      root: {
        ...selectboxFontStyle,
        fontWeight: theme.palette.type === 'dark' ? 500 : 600,
      },
      select: {
        '&:focus': {
          backgroundColor: 'none',
        },
      },
    },
    MuiInputBase:{
      root:{
        underline: {
          "&&:before": {
            borderBottom: "none"
          },
          "&&:after": {
            borderBottom: "none"
          }
        }
      }
    
    },
    // Select box font color and data-block area
    MuiMenuItem: {
      root: {
        ...selectboxFontStyle,
        fontWeight: theme.palette.type === 'dark' ? 500 : 600,
      },
    },
    MuiAppBar: {
      colorDefault: {
        backgroundColor: colors.colorWhite,
      },
    },
    MuiFormLabel: {
      root: {
        '& .MuiFormLabel-asterisk': {
          display: 'none',
        },
      },
    },
    MuiIconButton: {
      root: {
        borderRadius: '5px',
        padding: '5px',
        // backgroundColor: `${theme.palette.background.default}`,
        backgroundColor: 'transparent',
        color: theme.palette.text.primary,
        '&:hover': {
          color: theme.palette.primary.main,
          backgroundColor: 'transparent',
          // backgroundColor: `${theme.palette.background.default}`,
        },
      },
    },
    MuiTabs: {
      root: {
        backgroundColor: `${theme.palette.background.paper} !important`,
      },
      indicator: {
        backgroundColor: `${theme.palette.background.default} !important`,
      },
    },
    MuiTab: {
      // general overrides for your material tab component heres
      root: {
        backgroundColor: `${theme.palette.grey['A800']} !important`,
        color: `${theme.palette.grey['A1000']} !important`,
        '&$selected': {
          backgroundColor: `${theme.palette.background.default} !important`,
          color: `${theme.palette.primary.main} !important`,
        },
      },
    },
  };
  return theme;
};

export default getTheme;
